import React from "react";
import {Box, ChevronDownIcon, FormControl, InputLabel, MenuItem, Select} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicSelectSmall = () => {
  const [age, setAge] = React.useState(10);

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"Small size Select"}
        language={"js"}
        value={
          "<FormControl>\n" +
          "          <InputLabel >Small Select</InputLabel>\n" +
          "          <Select\n" +
          "            value={age}\n" +
          "            onChange={handleChange}\n" +
          '            size="small"\n' +
          "            fullWidth\n" +
          "            IconComponent={ChevronDownIcon}\n" +
          "          >\n" +
          "            <MenuItem value={10}>Tom Cook - Small</MenuItem>\n" +
          "            <MenuItem value={20}>Tom Cook - Twenty</MenuItem>\n" +
          "            <MenuItem value={30}>Tom Cook - Thirty</MenuItem>\n" +
          "          </Select>\n" +
          "        </FormControl>"
        }
      >
        <FormControl>
          <InputLabel>Small Select</InputLabel>
          <Select
            value={age}
            onChange={handleChange}
            size="small"
            fullWidth
            IconComponent={ChevronDownIcon}
          >
            <MenuItem value={10}>Tom Cook - Small</MenuItem>
            <MenuItem value={20}>Tom Cook - Twenty</MenuItem>
            <MenuItem value={30}>Tom Cook - Thirty</MenuItem>
          </Select>
        </FormControl>
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicSelectSmall;
